import { useAppSelector } from '@/store/hooks';
import { selectAllAttendeesSearch } from '@/store/slices/audiences/selectors';
import { EColorVariablesV2 } from '@/types/theme-packs.types';
import getProjectOverChannelColorCssVariable from '@/utils/colors/get-project-over-channel-color-css-variable';
import getThemeColorContrastCSSVariable from '@/utils/colors/get-theme-color-contrast-css-variable';
import getThemeColorsCssMixVariable from '@/utils/colors/get-theme-color-css-mix-variable';
import getThemeColorCSSVariable from '@/utils/colors/get-theme-color-css-variable';
import Button from '@ui/buttons/button/button';
import Container from '@ui/container/container';
import Text from '@ui/text/text/text';
import { Activity, useState } from 'react';
import CreateListModal from './create-list-modal';

const NoProfiles = ({ isAllProfiles }: { isAllProfiles: boolean }) => {
  const search = useAppSelector(selectAllAttendeesSearch);
  const hasFilters = !!search;
  const [createModalOpen, setCreateModalOpen] = useState(false);

  return (
    <Container className="flex fd-column ai-center jc-center gap-8" height="100%">
      <Text className="H3" color={getProjectOverChannelColorCssVariable(EColorVariablesV2.primary, 'global-cont-1')}>
        {hasFilters ? 'No users match your criteria' : "There's no one here yet"}
      </Text>

      <Activity mode={isAllProfiles ? 'visible' : 'hidden'}>
        <Text className="S1" design="GlobalIcoText2">
          {hasFilters
            ? 'Your filters may be too specific.'
            : 'You can add an existing list to this one or add profiles manually'}
        </Text>
        <Button
          className="flex fd-row ai-center gap-6 padding-v-16 padding-h-24 margin-t-24"
          borderRadius="100px"
          backgroundColor={getThemeColorCSSVariable()}
          hoverBackgroundColor={getThemeColorsCssMixVariable()}
          onClick={() => setCreateModalOpen(true)}
        >
          <Text
            className="L1"
            color={getThemeColorContrastCSSVariable(EColorVariablesV2.buttonText, EColorVariablesV2.primary)}
          >
            Add profiles
          </Text>
        </Button>
        <CreateListModal open={createModalOpen} setOpen={setCreateModalOpen} />
      </Activity>

      <Activity mode={isAllProfiles ? 'hidden' : 'visible'}>
        <Text className="S1" design="GlobalIcoText2">
          {hasFilters
            ? 'Your filters may be too specific.'
            : 'This list will auto-fill based on the registration/attendance data.'}
        </Text>
      </Activity>
    </Container>
  );
};

export default NoProfiles;
